import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { MatIconModule } from '@angular/material/icon';
import { ActivatedRoute } from '@angular/router';
import { environment } from '@config/environment';
import { map } from 'rxjs/operators';

@Component({
  selector: 'ba-login-failed',
  template: `
    <div class="app-main-container">
      <div class="error-page-container">
        <mat-icon class="material-symbols-outlined">mood_bad</mat-icon>
        <div class="mat-body">
          @if (loginFailedState(); as state) {
            @if (state.errorMessage) {
              <p>{{ state.errorMessage }}</p>
            }
            @if (state.showAdditionalInstructions) {
              <p>
                Looks like we need some additional details to appropriately
                configure your account. Please
                <a [href]="supportDeskUrl" class="color-primary">click here</a>
                to submit a ticket to our support desk. Our team will review the
                request and follow up with your account administrator to
                finalize your access role.
              </p>
            }
          }
          <p>
            To go back to login, click
            <a href="/login" class="color-primary">here</a>.
          </p>
        </div>
      </div>
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatIconModule],
})
export class LoginFailedComponent {
  private readonly _route = inject(ActivatedRoute);
  readonly supportDeskUrl = environment.supportDeskUrl;
  readonly loginFailedState = toSignal(
    this._route.queryParams.pipe(
      map((params) => ({
        errorMessage: params?.error,
        showAdditionalInstructions:
          params?.showAdditionalInstructions === 'true',
      }))
    ),
    {
      initialValue: {
        errorMessage: undefined,
        showAdditionalInstructions: false,
      },
    }
  );
}
